/**
 * #178 follow-up — classifica a falha do GET /telefonia/credenciais-sip.
 *
 * Nem todo agente atende telefone: quem não tem ramal vinculado não deve
 * manter webphone registrado nem socket /voice aberto (era essa população
 * que engordava o storm de reconexão do incidente de 09/07). O sinal "sem
 * ramal" é o próprio erro do endpoint de credenciais:
 *
 * - 400: controller da Platform — usuário sem ChatAgentSync (sem sync com o
 *   motor de voz);
 * - 404/422: motor de voz — agente sem ramal/credencial provisionada.
 *
 * 5xx / "not implemented" = motor indisponível (transitório — quem TEM ramal
 * continua vendo o estado de erro pra saber que a telefonia está fora);
 * 401/403 = auth (nunca esconder o webphone por isso); resto = genérico.
 */
export type ConnectErrorKind = "no_extension" | "unavailable" | "generic";

export function classifyConnectError(err: unknown): ConnectErrorKind {
  const e = err as { status?: number; message?: string } | null | undefined;
  const status = typeof e?.status === "number" ? e.status : undefined;

  if (status === 400 || status === 404 || status === 422) {
    return "no_extension";
  }
  if (
    (status !== undefined && status >= 500) ||
    (e?.message ?? "").toLowerCase().includes("not implemented")
  ) {
    return "unavailable";
  }
  return "generic";
}
